(() => {
  function initProduct(root) {
    if (root.dataset.productMainInitialized) return;
    root.dataset.productMainInitialized = 'true';
    root.querySelectorAll('[data-option-group]').forEach(group => {
      const options = group.querySelectorAll('.opt');
      options.forEach(button => button.addEventListener('click', () => {
        options.forEach(option => option.classList.toggle('sel', option === button));
      }));
    });

    const hasDesign = root.querySelector('[data-product-has-design]');
    const designOptions = root.querySelector('[data-product-design-options]');
    const designPanel = root.querySelector('[data-product-design-panel]');
    const updateDesignOptions = () => {
      const collapsed = Boolean(hasDesign?.checked);
      if (designOptions) designOptions.disabled = collapsed;
      if (designPanel) {
        designPanel.classList.toggle('is-collapsed', collapsed);
        designPanel.inert = collapsed;
        designPanel.setAttribute('aria-hidden', String(collapsed));
      }
      hasDesign?.setAttribute('aria-expanded', String(!collapsed));
    };
    hasDesign?.addEventListener('change', updateDesignOptions);
    updateDesignOptions();

    const designText = root.querySelector('[data-product-design-text]');
    designText?.addEventListener('input', () => {
      const lines = designText.value.split('\n');
      if (lines.length > 5) designText.value = lines.slice(0, 5).join('\n');
    });

    const form = root.querySelector('.product-form');
    if (!form) return;
    const variantsNode = form.querySelector('[data-product-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const variantInput = form.querySelector('[data-variant-id]');
    const sku = root.querySelector('[data-product-sku]');
    const price = root.querySelector('[data-product-price]');
    const compare = root.querySelector('[data-product-compare]');
    const optionInputs = [...root.querySelectorAll('[data-product-option]')];
    const money = amount => {
      const currency = window.Shopify?.currency?.active || document.documentElement.getAttribute('data-currency') || 'USD';
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(amount / 100);
    };
    const updateVariant = () => {
      const selectedOptions = optionInputs.map(input => input.value);
      const variant = variants.find(item => item.options.every((value, index) => value === selectedOptions[index])) || variants.find(item => String(item.id) === variantInput?.value);
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (sku) {
        sku.textContent = variant.sku || '—';
        sku.href = `${window.location.pathname}?variant=${variant.id}`;
      }
      if (price) price.textContent = money(variant.price);
      if (compare) {
        const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
        compare.hidden = !hasCompare;
        compare.textContent = hasCompare ? money(variant.compare_at_price) : '';
      }
    };
    optionInputs.forEach(input => input.addEventListener('change', updateVariant));

    root.addEventListener('consult:prepare', event => {
      const variant = variants.find(item => String(item.id) === variantInput?.value);
      const details = [
        `Product: ${root.dataset.productTitle}`,
        `SKU: ${variant?.sku || '—'}`,
      ];
      details.push(`I have a design: ${hasDesign?.checked ? 'Yes' : 'No'}`);
      if (!hasDesign?.checked) {
        details.push(`Text: ${root.querySelector('[data-product-design-text]')?.value.trim() || 'Not specified'}`);
        details.push(`I have a logo: ${root.querySelector('[data-product-has-logo]')?.checked ? 'Yes' : 'No'}`);
      }
      const unit = root.querySelector('[data-product-size-unit]')?.value || 'cm';
      const width = root.querySelector('[data-product-width]')?.value.trim();
      const height = root.querySelector('[data-product-height]')?.value.trim();
      details.push(`Width: ${width ? `${width} ${unit}` : 'Not specified'}`);
      details.push(`Height: ${height ? `${height} ${unit}` : 'Not specified'}`);
      const letterDepth = root.querySelector('[data-product-letter-depth]')?.value.trim();
      const letterDepthUnit = root.querySelector('[data-product-letter-depth-unit]')?.value || 'cm';
      details.push(`Letter Depth: ${letterDepth ? `${letterDepth} ${letterDepthUnit}` : 'Not specified'}`);
      root.querySelectorAll('.product-option-group').forEach(group => {
        const label = group.querySelector('h3')?.textContent.trim();
        const selection = group.querySelector('.opt.sel small')?.textContent.trim();
        details.push(`${label}: ${selection || 'Not selected'}`);
      });
      event.detail.configuration = details.join('\n');
    });
    updateVariant();
  }

  function boot() { document.querySelectorAll('[data-product-main]').forEach(initProduct); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
